import{stringifyScope as e}from"@nohara-dxdev/roles";const t=async(t,n,r)=>{let{data:i}=await t.get(`/users/${n}`,{params:{scope:e(r)}});return i};export{t as getUser};
//# sourceMappingURL=get-user.mjs.map